import { useStoreConfig } from '~/store/storeConfig'
import { useCategoryStore } from '~/store/categoryStore'

export const useCategoryWatch = () => {
  const locale = useState<string>('locale.setting')
  const storeConfig = useStoreConfig()
  const categoryStore = useCategoryStore()
  let stopWatch: (() => void) | undefined

  const initWatch = () => {
    stopWatch = watch(
      () => storeConfig.getCategoryDocKey,
      async (categoryDocKey: string) => {
        try {
          if (categoryDocKey) {
            categoryStore.setLoading(true)

            await categoryStore.getFlagsByLocale(locale.value)
            await categoryStore.getCategoriesByLocale(locale.value)
          }
        } catch {
        } finally {
          categoryStore.setLoading(false)
        }
      },
      { deep: true }
    )
  }

  onBeforeUnmount(() => {
    if (stopWatch) {
      stopWatch()
    }
  })

  return {
    initWatch,
  }
}
